import { render, staticRenderFns } from "./MessagesChart.vue?vue&type=template&id=d2cacc86&scoped=true"
import script from "./MessagesChart.vue?vue&type=script&lang=js"
export * from "./MessagesChart.vue?vue&type=script&lang=js"
import style0 from "./MessagesChart.vue?vue&type=style&index=0&id=d2cacc86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cacc86",
  null
  
)

export default component.exports